import { useCallback, useSyncExternalStore } from 'react';

/** Reagiert auf eine CSS-Media-Query (ohne matchMedia: false). */
export function useMediaQuery(query: string): boolean {
  // Stabile subscribe-Funktion: sonst meldet useSyncExternalStore bei jedem Rendern ab und wieder an.
  const subscribe = useCallback(
    (cb: () => void) => {
      const mq = window.matchMedia?.(query);
      mq?.addEventListener?.('change', cb);
      return () => mq?.removeEventListener?.('change', cb);
    },
    [query],
  );
  return useSyncExternalStore(subscribe, () => !!window.matchMedia?.(query).matches, () => false);
}

export const MOBILE_QUERY = '(max-width: 820px)';
